import Http from '../../shared/http';
import { ServerResponse } from '../types';
import {
    Domain, FQDN_API_PATH, RequestParams
} from './fqdn.types';

const http = Http.getHttp()

export const getFqdn = async (deliveryFunction: string): Promise<Domain[]> => {
    const { data: response } = await http.get<ServerResponse<Domain>>(`${FQDN_API_PATH}/${deliveryFunction}`);
    return response.data || [];
}

export const deleteFqdn = ({ deliveryFunction, id }: RequestParams) => http.delete<ServerResponse<Domain>>(`${FQDN_API_PATH}/${deliveryFunction}/${id}`);

export const createFqdn = ({ deliveryFunction, body }: RequestParams) => http.post<ServerResponse<Domain>>(`${FQDN_API_PATH}/${deliveryFunction}`, body);

export const updateFqdn = ({ deliveryFunction, body, id }: RequestParams) => deleteFqdn({ deliveryFunction, id }).then(() => createFqdn({ deliveryFunction, body }))
